import { User } from "@phosphor-icons/react";
import { PickerItemProps } from "../../types";

interface UserData {
  id: string;
  first_name: string | null;
  last_name: string | null;
  image_url: string;
  email_addresses?: { email_address: string }[];
}

export const UserItem = ({ item, isSelected, onSelect }: PickerItemProps<UserData>) => {
  const displayName = [item.first_name, item.last_name].filter(Boolean).join(' ')
    || item.email_addresses?.[0]?.email_address
    || 'Onbekende gebruiker';

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 flex items-center gap-3 border ${
        isSelected
          ? "bg-moss-primary/10 text-moss-primary border-moss-primary/40 ring-2 ring-moss-primary/20 shadow-sm"
          : "border-neutral-primary/10 hover:border-neutral-primary/20 hover:bg-neutral-primary/5 hover:shadow-sm"
      }`}
    >
      <img
        src={item.image_url}
        alt={displayName}
        className="h-9 w-9 rounded-full object-cover ring-2 ring-white shadow-sm shrink-0"
      />
      <span className="font-semibold text-neutral-primary">
        {displayName}
      </span>
    </button>
  );
};

export const NotAssignedItem = ({ isSelected, onSelect }: { isSelected: boolean; onSelect: () => void }) => {
  return (
    <button
      onClick={onSelect}
      className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 flex items-center gap-3 border ${
        isSelected
          ? "bg-moss-primary/10 text-moss-primary border-moss-primary/40 ring-2 ring-moss-primary/20 shadow-sm"
          : "border-neutral-primary/10 hover:border-neutral-primary/20 hover:bg-neutral-primary/5 hover:shadow-sm"
      }`}
    >
      <div className="h-9 w-9 bg-neutral-primary/10 rounded-full flex items-center justify-center ring-2 ring-white shadow-sm shrink-0">
        <User className="h-5 w-5 text-neutral-primary/60" weight="duotone" />
      </div>
      <span className="font-semibold text-neutral-primary">Niet toegewezen</span>
    </button>
  );
};